import Vue from 'vue';
import Vuex, { mapState } from 'vuex';
import VueRouter from 'vue-router';
import * as VuexRouterSync from 'vuex-router-sync';
import VueLog from '@dreipol/vue-log';
import createStore from 'framework/vuex';
import createRouter from 'framework/router';
import registry from './registry';
import vueLogConfig from './vue-log-config';
import vuexViewportMixin from 'framework/vuex/modules/viewport/mixin';
import { bemMixin, scrollMixin } from '@dreipol/vue-ui/src/mixins';
import * as vueUiSettings from '@dreipol/vue-ui/src/settings';
import { ClientTable } from 'vue-tables-2';

const CMS = window.CMS;
const isInCMS = Boolean(CMS);
const hasVueRouter = globals.config.router.isSpa;

/**
 * Bootstrap the vue root instance
 * @return {Promise} A promise returning when the registry has loaded all components and the app was initialized
 */
export function init() {
    // NOTE: Plugin initialisation is run before registry because new merge strategies might be applied by plugins.
    Vue.use(Vuex);
    if (hasVueRouter) {
        Vue.use(VueRouter);
    }
    Vue.use(VueLog, vueLogConfig);
    Vue.use(ClientTable);

    // if we are logged into the CMS we need to stop the vue warnings
    // the django-CMS will add dirty stuff to the DOM and vue doesn't like it
    Vue.config.silent = isInCMS;

    vueUiSettings.default.set(vueUiSettings.SELECT_ICON, {
        symbol: 'triangle-down',
        size: 'small',
    });

    return registry().then(() => {
        const store = createStore();
        const appPlugins = hasVueRouter ? { store, router: createRouter() } : { store };

        const AppRoot = new Vue({
            ...appPlugins,
            mixins: [vuexViewportMixin, scrollMixin, bemMixin('skel')],
            computed: {
                ...mapState('desktop-menu', ['isOpen']),
                ...mapState('header-search', ['isVisible']),
                rootClasses() {
                    return [
                        this.bemIf(this.isOpen || this.isVisible, 'is-menu-open'),
                    ];
                },
            },
            renderError(h, err) {
                return h('pre', { style: { color: 'red' } }, err.stack);
            },
        });

        if (hasVueRouter) {
            VuexRouterSync.sync(store, appPlugins.router);
        }

        AppRoot.$mount('#root');

        // If logged into the CMS we need to refresh the plugins after the vue rendering
        // this is needed to enable the frontend editing
        if (isInCMS) {
            requestAnimationFrame(() => {
                CMS.Plugin._refreshPlugins();
            });
        }
    });
}
